import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import useDialogBehavior from '../../hooks/useDialogBehavior'
import '../../css/ConfirmModal.css'

const ConfirmModal = ({ message, confirmLabel, cancelLabel, onConfirm, onCancel }) => {
	const { t } = useTranslation('common')
	const isConfirm = Boolean(onCancel)
	const dialogRef = useDialogBehavior(onCancel ?? onConfirm)

	return (
		<div className='confirm-modal-overlay' onClick={onCancel ?? onConfirm}>
			<div
				className='confirm-modal'
				onClick={e => e.stopPropagation()}
				ref={dialogRef}
				role='alertdialog'
				aria-modal='true'
				aria-label={message}
			>
				<AlertTriangle size={22} className='confirm-modal-icon' aria-hidden='true' />
				<p className='confirm-modal-message'>{message}</p>
				<div className='confirm-modal-actions'>
					{isConfirm && (
						<button type='button' className='btn-secondary-action' onClick={onCancel}>
							{cancelLabel || t('cancel')}
						</button>
					)}
					<button type='button' className='btn-primary-action' onClick={onConfirm}>
						{confirmLabel || t('ok')}
					</button>
				</div>
			</div>
		</div>
	)
}

export default ConfirmModal
